import { FleetDriver, FleetDriverTab, GorilaDriver } from '../types/drivers';

export function isFleetDriverTab(value: string): value is FleetDriverTab {
  return Object.values(FleetDriverTab).includes(value as FleetDriverTab);
}

export function isUnknownDriver(driver: FleetDriver | GorilaDriver) {
  const unknownValues = new Set(['N/A', '', null, undefined]);
  return unknownValues.has(driver.name) && unknownValues.has(driver.lastName);
}

export function getDriverFullName(driver: FleetDriver | GorilaDriver) {
  return isUnknownDriver(driver) ? driver.name : `${driver.name} ${driver.lastName}`;
}

export function isGorilaDriver(value: Object | undefined): value is GorilaDriver {
  return (
    typeof value === 'object' &&
    value !== undefined &&
    value !== null &&
    'driverId' in value &&
    'name' in value &&
    'lastName' in value &&
    'key' in value &&
    'detectedKey' in value
  );
}
